import React from "react";

import Loading from "../../components/Loading";

import layout from "../../components/layout";
import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const Profile = () => {
  const { loading, user } = useAuth0();

  if (loading || !user) {
    return <Loading />;
  }

  return (
    <div className="profile page-container">
      <h1>Profile</h1>
      <div className="profile-info">
        <img
          src={user.picture}
          alt="Profile"
          className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
        />
        <h2 className="title">{user.name}</h2>
      </div>
    </div>
  );
};

export default layout(Profile);
